import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useRef, useEffect } from "react";
import classnames from "classnames";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import config from "../../config"; // state

import withUserMenu from "./UserMenu.store"; // components

import Icon from "../Icon"; // components

import RecentSearches from "./components/RecentSearches";
import RecentlyViewed from "./components/RecentlyViewed";
import Compare from "./components/Compare";
import styles from "./UserMenu.module.scss";

var menu = ["recently-viewed", "searches", "compare"],
    UserMenuComponent = function UserMenuComponent(a) {
  var b = a.userMenu,
      c = a.className,
      d = _objectWithoutProperties(a, ["userMenu", "className"]),
      e = useRef(),
      f = _slicedToArray(b, 2),
      g = f[0],
      h = f[1],
      i = g.show,
      j = g.active,
      k = function k(a) {
    return function () {
      return h.toggle(a);
    };
  },
      l = _defineProperty({}, styles.show, i && j);

  useEffect(function () {
    var a = e.current;
    return i && j && a && disableBodyScroll(a), function () {
      return enableBodyScroll(a);
    };
  }, [i, j]), useEffect(function () {
    document.body.style.marginBottom = config.userCustomisationMenu.get("height") || "53px";
  }, []);

  var m = j ? [] : menu,
      n = _slicedToArray(m, 1),
      o = n[0];

  return /*#__PURE__*/React.createElement("div", {
    className: "ta-user-menu"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: k(!1),
    className: classnames(styles.backdrop, l)
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.container, c, l)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.menuWrapper
  }, /*#__PURE__*/React.createElement("ul", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("li", {
    className: styles.title
  }, "MY"), menu.map(function (a) {
    var b = a.split("-").join(" ");
    return /*#__PURE__*/React.createElement("li", {
      key: a,
      className: classnames(_defineProperty({}, styles.active, i && j === a))
    }, /*#__PURE__*/React.createElement("button", {
      onClick: k(a)
    }, b));
  }), /*#__PURE__*/React.createElement("li", {
    className: styles.close
  }, /*#__PURE__*/React.createElement("button", {
    className: styles.closeButton,
    onClick: k(o)
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "chevron"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, j ? /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.titleContainer, "ta-container")
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement("h1", {
    className: classnames(styles.title, styles[j])
  }, "searches" === j ? "Recent Searches" : "recently-viewed" === j ? "Recently Viewed" : "compare" === j ? "Compare List" : null))) : null, /*#__PURE__*/React.createElement("div", {
    ref: e,
    className: classnames(styles.wrapper, styles[j])
  }, "searches" === j ? /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement(RecentSearches, {
    onPackageClick: k(!1)
  })) : "compare" === j ? /*#__PURE__*/React.createElement(Compare, {
    onPackageClick: k(!1)
  }) : "recently-viewed" === j ? /*#__PURE__*/React.createElement(RecentlyViewed, {
    onPackageClick: k(!1)
  }) : null))));
};

export var UserMenu = withUserMenu(UserMenuComponent);
export default UserMenu;